export default "__VITE_ASSET__C_3F7lKX__";